<template>
  <div class="clearfix main_center">
    <div class="top-content">
      <div class="left-navbar">
        <el-button size="small" @click="backBtn">返回</el-button>
        <el-button type="primary" size="small" plain style="margin-right:10px;"
          v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_add')" @click="routerEdit()">编辑</el-button>

      </div>
    </div>
    <div class="right-content">
      <el-form ref="form" :model="form" label-width="150px" class="form viewFormWrapper">
        <el-card class="box-card" style="margin-bottom: 0px" :style="{ 'height': cardHight }">
          <div slot="header" class="clearfix">
            <span>第三方对接系统配置信息</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="系统名称：">
                <span>{{ form.systemName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属单位：">
                <span>{{ form.orgName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="访问token：">
                <span>{{ form.token }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="访问地址：">
                <span>{{ form.accessUrl }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="回调接口：">
                <span>{{ form.callback }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接口密钥：">
                <span>{{ form.secrets }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="接口类型：">
                <span>{{ form.interTypeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文件获取方式：">
                <span>{{ form.fileDownModName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属交易中心：">
                <span>{{ form.tradeIdName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
    </div>


  </div>
</template>

<script>

import { mapState } from "vuex";
// import {tabsCloseCurrentHandle} from '@/utils/routeTab';

export default {
  components: {

  },
  data() {
    return {
      cardHight: (document.documentElement.clientHeight - 108) + 'px',
      form: {
        systemName: '',//系统名称
        orgName: '',//所属单位
        token: '',//访问token
        accessUrl: '',//访问地址
        callback: '',//回调接口
        secrets: '',//接口密钥
        interType: '',//接口类型
        interTypeName: '',//接口类型
        fileDownMod: '',//文件获取方式
        fileDownModName: '',//文件获取方式
        tradeIdName:"",
      },
      id: '', //点击提交的时候也传id
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    })
  },
  activated() {

    this.id = window.sessionStorage.getItem("id")
    this.getDataById()

  },
  methods: {
    backBtn() { //返回
      tabsCloseCurrentHandle();
      this.$router.push({
        name: 'thirds_config_list'
      })
      this.$refs.form.resetFields();
    },
    routerEdit() {
      this.$router.push({
        name: 'thirds_config_detail'
      })
    },
    getDataById() { //详情

      if (this.id != "") {

        this.$httpReq.get('/thirdsConfig/get?id=' + this.id).then(res => {
          if (res.data.code == '1') {
            this.id = res.data.data.id
            const data = res.data.data
            this.form = {
              id: this.id,
              systemName: data.systemName,//系统名称
              orgName: data.orgName,//所属单位
              token: data.token,//访问token
              accessUrl: data.accessUrl,//访问地址
              callback: data.callback,//回调接口
              secrets: data.secrets,//接口密钥
              interType: data.interType,//接口类型
              interTypeName: data.interTypeName,//接口类型
              fileDownMod: data.fileDownMod,//文件获取方式
              fileDownModName: data.fileDownModName,//文件获取方式
              tradeIdName:data.tradeIdName, // 所属交易中心
            }
          }
        })

      }
    },

  }



}
</script>

<style lang="scss" scoped>
</style>